export enum EPageType {
  N1 = 'n1',
  MAIL = 'mail',
  MAIN = 'main',
  MEDIA = 'media',
  APPLICATION = 'application',
  SUBURBAN = 'suburban',
}
